class MetricManager {
  constructor(data) {
    this.data = data;
    this.total_sposored_session = data.sponsored_sessions;
    this.total_session_utilized = data.total_sessions;
    this.activeCustomerCount = data.active_customers_count ?? 0
    this.unique_users = data.unique_users ?? 0
    this.repeat_users = data.repeat_users ?? 0
    this.coverage = data.coverage;
    this.total = this.getTotal();
    this.donutGraphData = this.donutGraphData();
  }

  apiResponse() {
    return this.data;
  }

  getTotal() {
    let total = 0;
    this.data.session_wise_booking.forEach((item) => {
      total = total + item[1];
    });
    return total;
  }

  getColorAndTooltip = (key) => {
    switch (key) {
      case 'Morning':
        return ['#60A5FA', '12am to 12pm'];
      case 'Afternoon':
        return ['#3FCB7F', '12pm to 4pm'];
      case 'Evening':
        return ['#D97706', '4pm to 8pm'];
      case 'Night':
        return ['#916C00', '8pm to 12am'];
      default:
        return '';
    }
  };

  donutGraphData() {
    const { session_wise_booking } = this.data;
    let n = session_wise_booking.length,
      total_sum = 0;

    return session_wise_booking.map(([type, num], index) => {
      let per = Math.round((num / this.total) * 100);

      if (index === n - 1 && total_sum + per < 100) per += 100 - (total_sum + per);
      else if (total_sum + per > 100) per -= total_sum + per - 100;
      else total_sum += per;

      const colorAndTooltip = this.getColorAndTooltip(type);
      return {
        text: type,
        number: num,
        percentage: per,
        color: colorAndTooltip[0],
        tooltip: colorAndTooltip[1],
      };
    });
  }
}

export default MetricManager;
